var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoNameWhite = function SvgLogoNameWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188.176,
    height: 44.136,
    viewBox: "0 0 188.176 44.136",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263",
    transform: "translate(-81.068 -84.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261",
    transform: "translate(81.068 84.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258",
    transform: "translate(1.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M248.252,66.3c4.958-.718,10.9,1.81,13.248,5.634l1.986,3.237-2.1.3L259.4,72.234c-1.8-2.93-6.35-4.865-10.148-4.316l-22.1,3.2c-3.8.549-5.423,3.379-3.624,6.309l10.461,17.044c1.8,2.928,6.348,4.863,10.145,4.314l22.1-3.2c3.8-.55,5.425-3.38,3.628-6.308l-1.987-3.238,2.1-.3,1.987,3.238c2.346,3.822.222,7.518-4.736,8.235l-22.1,3.2c-4.958.718-10.9-1.81-13.245-5.633L221.423,77.73c-2.347-3.824-.225-7.519,4.733-8.236Z",
    transform: "translate(-220.467 -66.173)",
    fill: "#aac208"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259",
    transform: "translate(0 9.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M243.033,97.739c4.958-.718,10.9,1.81,13.248,5.634l1.986,3.237-2.1.3-1.986-3.237c-1.8-2.93-6.35-4.865-10.148-4.315l-22.1,3.2c-3.8.55-5.423,3.379-3.624,6.309l10.461,17.044c1.8,2.928,6.349,4.863,10.145,4.314l22.1-3.2c3.8-.55,5.425-3.38,3.628-6.308l-1.987-3.238,2.1-.3,1.987,3.238c2.346,3.822.222,7.518-4.736,8.235l-22.1,3.2c-4.958.717-10.9-1.81-13.245-5.633L216.2,109.174c-2.347-3.824-.225-7.519,4.733-8.236Z",
    transform: "translate(-215.248 -97.617)",
    fill: "#aac208"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262",
    transform: "translate(149.325 95.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M103.381,259.688v-7.38c0-3.9,2.793-6.5,6.953-6.5s6.925,2.508,6.925,6.3c0,.2-.171.313-.427.342l-1.881.114c-.285.028-.427-.057-.427-.171v-.171a4.206,4.206,0,0,0-8.407,0v7.58a4.206,4.206,0,0,0,8.407,0c0-.2.142-.342.427-.313l1.881.114c.256.029.427.057.427.142v.142c0,3.79-2.764,6.355-6.925,6.355S103.381,263.621,103.381,259.688Z",
    transform: "translate(-103.381 -245.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M173.557,248.907h-9.945a.135.135,0,0,0-.142.143v6.07a.135.135,0,0,0,.142.142h6.782a.4.4,0,0,1,.427.427v1.51a.4.4,0,0,1-.427.428h-6.782a.134.134,0,0,0-.142.142v6.212a.135.135,0,0,0,.142.143h9.945a.4.4,0,0,1,.427.427v1.51a.4.4,0,0,1-.427.427h-12.4a.4.4,0,0,1-.427-.427V246.97a.4.4,0,0,1,.427-.428h12.4a.4.4,0,0,1,.427.428v1.51A.4.4,0,0,1,173.557,248.907Z",
    transform: "translate(-142.894 -246.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M213.778,259.688v-7.38c0-3.9,2.793-6.5,6.953-6.5s6.925,2.508,6.925,6.3c0,.2-.171.313-.427.342l-1.881.114c-.285.028-.427-.057-.427-.171v-.171a4.207,4.207,0,0,0-8.407,0v7.58a4.207,4.207,0,0,0,8.407,0c0-.2.142-.342.427-.313l1.881.114c.256.029.427.057.427.142v.142c0,3.79-2.764,6.355-6.925,6.355S213.778,263.621,213.778,259.688Z",
    transform: "translate(-179.438 -245.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_16",
    "data-name": "Caminho 16",
    d: "M278.582,268.124v9.489a.4.4,0,0,1-.427.427h-1.881a.4.4,0,0,1-.427-.427v-.8c0-.114-.086-.171-.171-.086a6.134,6.134,0,0,1-4.275,1.539c-2.565,0-4.759-1.254-4.759-4.3,0-2.935,2.137-4.759,5.9-4.759H275.7a.135.135,0,0,0,.142-.142v-.741c0-1.624-.912-2.65-2.935-2.65-1.6,0-2.565.627-2.85,1.624a.416.416,0,0,1-.485.342l-2.051-.256c-.257-.029-.427-.171-.4-.37.342-2.137,2.593-3.7,5.728-3.7C276.416,263.308,278.582,265.331,278.582,268.124Zm-2.735,5.016v-1.653a.135.135,0,0,0-.142-.142h-2.651c-2.223,0-3.676.883-3.676,2.479,0,1.453,1.2,2.137,2.707,2.137C274.051,275.961,275.846,274.821,275.846,273.14Z",
    transform: "translate(-215.858 -257.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M324.742,263.9a.432.432,0,0,1,.228.542l-.4,1.852c-.057.314-.228.342-.513.257a3.5,3.5,0,0,0-1.4-.114,3.058,3.058,0,0,0-3.078,3.192V277.8a.4.4,0,0,1-.427.427h-1.881a.4.4,0,0,1-.427-.427v-13.65a.4.4,0,0,1,.427-.427h1.881a.4.4,0,0,1,.427.427v1.311c0,.142.085.171.142.057a4.009,4.009,0,0,1,3.476-1.938A3.556,3.556,0,0,1,324.742,263.9Z",
    transform: "translate(-250.448 -258.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M363.039,259.195a10.843,10.843,0,0,1-.513,3.648,5.3,5.3,0,0,1-5.386,3.875,4.243,4.243,0,0,1-3.306-1.482c-.086-.085-.171-.029-.171.086v.741a.4.4,0,0,1-.428.427h-1.881a.4.4,0,0,1-.427-.427V246.97a.4.4,0,0,1,.427-.428h1.881a.4.4,0,0,1,.428.428v6.184c0,.114.085.142.171.057a4.313,4.313,0,0,1,3.306-1.453,5.344,5.344,0,0,1,5.471,3.99A11.653,11.653,0,0,1,363.039,259.195Zm-2.736.057a6.77,6.77,0,0,0-.912-3.762,2.868,2.868,0,0,0-2.536-1.368,2.655,2.655,0,0,0-2.423,1.453,7.35,7.35,0,0,0-.741,3.648,7.573,7.573,0,0,0,.684,3.591,2.736,2.736,0,0,0,2.479,1.539,2.894,2.894,0,0,0,2.735-1.567A7.442,7.442,0,0,0,360.3,259.252Z",
    transform: "translate(-273.927 -246.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M400.089,274.222a11.593,11.593,0,0,1-.513-3.477,11.122,11.122,0,0,1,.484-3.419,6.264,6.264,0,0,1,11.684-.029,10.772,10.772,0,0,1,.513,3.419,11.321,11.321,0,0,1-.513,3.505,6.219,6.219,0,0,1-11.655,0Zm9.09-.77a10.463,10.463,0,0,0,.314-2.678,10.869,10.869,0,0,0-.285-2.65,3.416,3.416,0,0,0-6.554,0,9.491,9.491,0,0,0-.313,2.65,10.01,10.01,0,0,0,.313,2.678,3.4,3.4,0,0,0,6.526,0Z",
    transform: "translate(-307.442 -257.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M463.338,268.415v9.261a.4.4,0,0,1-.427.427H461.03a.4.4,0,0,1-.427-.427v-8.72a3.048,3.048,0,0,0-6.07-.513v9.233a.4.4,0,0,1-.427.427h-1.881a.4.4,0,0,1-.427-.427v-13.65a.4.4,0,0,1,.427-.427h1.881a.4.4,0,0,1,.427.427v.8c0,.114.085.171.143.086a4.279,4.279,0,0,1,3.591-1.51A4.7,4.7,0,0,1,463.338,268.415Z",
    transform: "translate(-343.42 -257.928)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNameWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-name-white.3a8e023c.svg";
export { ForwardRef as ReactComponent };